const MAX_NUMBER_OF_FILES = 8;
const MAX_NUMBER_OF_PHOTOS = 12;
const MAX_PHOTO_WIDTH_OR_HEIGHT = 1280;

export default {
  MAX_NUMBER_OF_FILES,
  MAX_NUMBER_OF_PHOTOS,
  MAX_PHOTO_WIDTH_OR_HEIGHT,
};



// WEBPACK FOOTER //
// ./src/constants/MiscConstants.js